// Imports
import PhotoSwipe from './components/PhotoSwipe';
import Tools from './tools/Tools';
import Plyr from './components/Plyr';

let Mwb = {
	
	init() {
		
		this.attachCookieDisclaimer();
		this.agency();
		this.contactMe();
		
		this.attachPlyr();
		
		this.attachTooltips();
		
	},
	
	/**
	 * @author Filipe DA COSTA
	 */
	attachCookieDisclaimer() {
		
		$('.glre-cookie.cookie').each((aIndex, aElement) => {
			
			console.log('test');
			
			let element = $(aElement);
			let button = element.find('.glre-cookie__btn');
			
			if (Tools.readCookie('globalrestoreCookieDisclaimerAccepted') !== null) {
				element.remove();
			} else {
				element.show();
			}
			
			button.on('click', (event) => {
				Tools.writeCookie('globalrestoreCookieDisclaimerAccepted', true, 364); // 1 year
				element.remove();
			});
			
		});
		
	},
	
	agency() {
		
		(function ($) {
			"use strict"; // Start of use strict
			
			// Smooth scrolling using jQuery easing
			$('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
				if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
					if (target.length) {
						$('html, body').animate({
							scrollTop: (target.offset().top - 54)
						}, 1000, "easeInOutExpo");
						return false;
					}
				}
			});
			
			// Closes responsive menu when a scroll trigger link is clicked
			$('.js-scroll-trigger').click(function () {
				$('.navbar-collapse').collapse('hide');
			});
			
			// Activate scrollspy to add active class to navbar items on scroll
			// $('body').scrollspy({
			//   target: '#mainNav',
			//   offset: 56
			// });
			
			// Collapse Navbar
			var navbarCollapse = function () {
				if ($("#mainNav").offset().top > 100) {
					$("#mainNav").addClass("navbar-shrink");
				} else {
					$("#mainNav").removeClass("navbar-shrink");
				}
			};
			// Collapse now if page is not at top
			navbarCollapse();
			// Collapse the navbar when page is scrolled
			$(window).scroll(navbarCollapse);
			
			// Hide navbar when modals trigger
			$('.portfolio-modal').on('show.bs.modal', function (e) {
				$('.navbar').addClass('d-none');
			})
			$('.portfolio-modal').on('hidden.bs.modal', function (e) {
				$('.navbar').removeClass('d-none');
			})
			
		})(jQuery); // End of use strict
		
	},
	
	contactMe() {
		
		$(function () {
			
			$("#contactForm input,#contactForm textarea").jqBootstrapValidation({
				preventSubmit: true,
				submitError: function ($form, event, errors) {
					// additional error messages or events
				},
				submitSuccess: function ($form, event) {
					event.preventDefault(); // prevent default submit behaviour
					// get values from FORM
					var name = $("input#name").val();
					var email = $("input#email").val();
					var phone = $("input#phone").val();
					var message = $("textarea#message").val();
					var firstName = name; // For Success/Failure Message
					// Check for white space in name for Success/Fail message
					if (firstName.indexOf(' ') >= 0) {
						firstName = name.split(' ').slice(0, -1).join(' ');
					}
					let $this = $("#sendMessageButton");
					$this.prop("disabled", true); // Disable submit button until AJAX call is complete to prevent duplicate messages
					$.ajax({
						url: "https://microsite.mooon-web.com/contact.php",
						type: "POST",
						data: {
							name: name,
							phone: phone,
							email: email,
							message: message,
							websiteName: 'Global reStore',
							websiteDns: 'global-restore.com'
						},
						cache: false,
						success: function () {
							// Success message
							$('#success').html("<div class='alert alert-success'>");
							$('#success > .alert-success').html("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;")
								.append("</button>");
							$('#success > .alert-success')
								.append("<strong>Votre message a bien été envoyé. </strong>");
							$('#success > .alert-success')
								.append('</div>');
							
							//clear all fields
							$('#contactForm').trigger("reset");
							
							//clear all fields
							$('#contactForm').trigger("reset");
							
							//clear all fields
							$('#contactForm').trigger("reset");
						},
						error: function () {
							// Fail message
							$('#success').html("<div class='alert alert-danger'>");
							$('#success > .alert-danger').html("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;")
								.append("</button>");
							$('#success > .alert-danger').append("<strong>Désolé " + firstName + ", il semblerait que notre serveur mail ne soit pas disponible. Veuillez réessayer plus tard!");
							$('#success > .alert-danger').append('</div>');
						},
						complete: function () {
							setTimeout(function () {
								$this.prop("disabled", false); // Re-enable submit button when AJAX call is complete
							}, 1000);
						}
					});
				},
				filter: function () {
					return $(this).is(":visible");
				},
			});
			
			$("a[data-toggle=\"tab\"]").click(function (e) {
				e.preventDefault();
				$(this).tab("show");
			});
		});
		
		/*When clicking on Full hide fail/success boxes */
		$('#name').focus(function () {
			$('#success').html('');
		});
		
	},
	
	/**
	 * @author Raphaël TSINGOS
	 */
	attachPlyr() {
		new Plyr();
	},
	
	attachContentPaddingBottom(){
		let height = $('footer').innerHeight();
		$('.content').css('margin-bottom', height + 'px');
		$(window).on('resize', () => {
			let height = $('footer').innerHeight();
			$('.content').css('margin-bottom', height + 'px');
		});
	},
	
	attachTooltips(){
		$('.tooltips').each((aIndex, aElement) => {
			let el = $(aElement);
			el.tooltip();
		});
	}
	
};

Mwb.init();